import { getSessonStorage } from './index';

export const getOrderDesc = (type: number): any => {
  if (type === 1) {
    return [{ col: 'hot', asc: false }, { col: 'scheduleCount', asc: false }, { col: 'movieCount', asc: false }];
  } else if (type === 2) {
    return [{ col: 'distance', asc: true }]; // true 是正序
  } else if (type === 3) {
    return [{ col: 'price', asc: true }];
  } else {
    return [];
  }
};


/**
 * 处理当前城市拼音
 * @param { name } string // 当前城市
 * @return { str } string // 返回城市英文
 */
export function getCityPinyin(name) {
  let str = name;
  const cityList = JSON.parse(getSessonStorage('cityList'));
  if (cityList && cityList.length > 0) {
    cityList.forEach((element) => {
      if (element.name == name) {
        console.log('element.pinyin', element.pinyin);
        str = element.pinyin;
        return;
      }
    });
    return str;
  } else {
    return str;
  }
}

// 判断当前是什么品牌手机
export function judgeBrand(sUserAgent) {
  var isIphone = sUserAgent.match(/iphone/i) == 'iphone';
  var isHuawei = sUserAgent.match(/huawei/i) == 'huawei';
  var isHonor = sUserAgent.match(/honor/i) == 'honor';
  var isOppo = sUserAgent.match(/oppo/i) == 'oppo';
  var isOppoR15 = sUserAgent.match(/pacm00/i) == 'pacm00';
  var isVivo = sUserAgent.match(/vivo/i) == 'vivo';
  var isXiaomi = sUserAgent.match(/mi\s/i) == 'mi ';
  var isXiaomi2s = sUserAgent.match(/mix\s/i) == 'mix ';
  var isRedmi = sUserAgent.match(/redmi/i) == 'redmi';
  var isSamsung = sUserAgent.match(/sm-/i) == 'sm-';

  if (isIphone) {
      return 'iphone';
  } else if (isHuawei || isHonor) {
      return 'huawei';
  } else if (isOppo || isOppoR15) {
      return 'oppo';
  } else if (isVivo) {
      return 'vivo';
  } else if (isXiaomi || isRedmi || isXiaomi2s) {
      return 'xiaomi';
  } else if (isSamsung) {
      return 'samsung';
  } else {
      return 'default';
  }
}